<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="formGroup">
    
    <div class="clearfix">
      <!---------------------------->
      <!-- Override Indicator 1:-->
      <!---------------------------->
      <div class="override-toggle-row">
        <app-element-slide-toggle [label]="overrideIndicatorNames.overrideIndicator1"
                                  [disabled]="formGroup.get(controls.ClaimOverrideIndicator1).disabled"
                                  [formControlName]="controls.ClaimOverrideIndicator1"></app-element-slide-toggle>
      </div>
    </div>
  
  </form>
  <mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button color="warn" (click)="onCancelDialogClick()">Cancel</button>
    <button class="dialog-button" mat-raised-button color="primary" (click)="onSubmitClick()">Okay</button>
  </mat-dialog-actions>
</div>
